import React from 'react';
import TestimonialSection from './TestimonialSectionAbout';
import Vision from './Visionn';

const AboutSection = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">About Us</h1>
            <div className="breadcumb-menu-wrap"></div>
          </div>
        </div>
      </div>

      <section className="space">
        <div className="container">
          <div className="row align-items-center">
            {/* Image Column */}
            <div className="col-lg-6">
              <div className="image-box1">
                <img className="img1" src="\img\6.png" alt="Platinum24 Cabs Fleet" />
                {/* <img className="img2" src="/img/about/img-2-2.jpg" alt="Platinum24 Cabs Service" /> */}

                <div className="media-box1">
                  <span className="media-info">5+ Years</span>
                  <p className="media-text">Of Trusted Service</p>
                </div>

                {/* <div className="media-box2">
                  <span className="media-info">50,000+</span>
                  <p className="media-text">Satisfied Customers</p>
                </div> */}
              </div>
            </div>

            {/* Content Column */}
            <div className="col-lg-5">
              <div className="about-content">
                <div className="title-area">
                  <span className="sec-subtitle">We are Platinum24 Cabs</span>
                  <h2 className="sec-title h1">Your Reliable Partner for Safe and Comfortable Travel</h2>
                  <p className="sec-text">
                    Platinum24 Cabs has been serving Pune and surrounding areas with dependable and affordable taxi services for over a decade.
                    Whether you need local rides, airport transfers, outstation trips, or corporate travel solutions, we provide professional drivers and well-maintained vehicles for your convenience.
                    Our commitment is to ensure safe, timely, and comfortable journeys for every customer.
                  </p>
                </div>

                <ul className="about-list1">
                  <li>24/7 Cab Service with Professional Drivers</li>
                  <li>Wide Range of Vehicles – Sedans, SUVs, 8-Seaters & More</li>
                  <li>Transparent Pricing with No Hidden Charges</li>
                  <li>Flexible Booking – Hourly, Daily, Outstation Trips</li>
                  <li>Airport Transfers with Real-time Flight Tracking</li>
                  <li>Corporate & Family Travel Packages Available</li>
                  <li>Customer Satisfaction is Our Top Priority</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Vision />
      <TestimonialSection />
    </>
  );
};

export default AboutSection;
 